import React, { useContext, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Application from "../../StateContext/Application";
import GooglePagination from "../../styles/GooglePagination";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const VendorExcelUpload = () => {
  const operation = useContext(Application);
  const { uploadworkorder, uploadVendorExcel } = operation;
  const [tableData, setTableData] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? filteredBills.length : 10;
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLast = currentPage * billsPerPage;
  const indexOfFirst = indexOfLast - billsPerPage;
  const currentBills = filteredBills.slice(indexOfFirst, indexOfLast);

  // ✅ DB Columns (STRICT MATCH)
  const expectedColumns = [
    "Bidder_CompanyName",
    "Address",
    "City",
    "PinCode",
    "GST_No",
    "PAN_No",
    "TAN_No",
    "AadharNo",
    "Mobile_No",
    "Email",
    "Account_Number",
    "IFSC_CODE",
    "BANK_NAME",
    "BranchName",
    "Account_HolderName",
    "MICRNo",
  ];

  // ✅ FILE UPLOAD
  const handleFileUpload = (e) => {
    setLoading(true);
    const file = e.target.files[0];

    if (!file) {
      alert("Select file");
      setLoading(false);
      return;
    }

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary",cellText: true,cellDates: true, });
        // const wb = XLSX.read(evt.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(ws, { defval: null , raw: false,});
        // const json = XLSX.utils.sheet_to_json(ws, { defval: null });

        if (!json.length) {
          alert("Empty file");
          setLoading(false);
          return;
        }

        const fileCols = Object.keys(json[0]);
        const missing = expectedColumns.filter((c) => !fileCols.includes(c));

        if (missing.length > 0) {
          alert("Please Upload Correct Formated Excel File Only");
          //   alert("Missing Columns:\n" + missing.join(", "));
          setLoading(false);
          return;
        }

        setTableData(json);
        setFilteredBills(json);
        setLoading(false);
      } catch (err) {
        console.error(err);
        alert("Invalid Excel");
        setLoading(false);
      }
    };

    reader.readAsBinaryString(file);
  };

  // ✅ SUBMIT
  const handleSubmit = async () => {
  if (!tableData.length) {
    return alert("No data");
  }

  try {
    setLoading(true);

    const res = await uploadVendorExcel(tableData);

    if (res?.status) {
      alert(res?.message || "Uploaded Successfully");

      setTableData([]);
      setFilteredBills([]);
      setCurrentPage(1);

      window.location.reload();
    } else if (res?.duplicates?.length) {
      // Duplicates within the uploaded Excel itself
      const lines = res.duplicates
        .map(
          (d) =>
            `Row ${d.Row - 1}: Account_Number "${d.Account_Number}" is a duplicate of row ${d.DuplicateOfRow}`
        )
        .join("\n");
      alert(`Duplicate rows found in uploaded Excel:\n\n${lines}`);
    } else if (res?.existing?.length) {
      // Duplicates already present in the database
      const lines = res.existing
        .map(
          (d) =>
            `Row ${d.Row ?? "?"}: Account_Number "${d.Account_Number}" (${d.Bidder_CompanyName}) already exists in database`
        )
        .join("\n");
      alert(`These vendors already exist:\n\n${lines}`);
    } else {
      alert(res?.message || "Upload failed");
    }

    setLoading(false);
  } catch (err) {
    console.error(err);
    alert("Upload failed");
    setLoading(false);
  }
};

  //--> old code
  // const handleSubmit = async () => {
  //   if (!tableData.length) {
  //     return alert("No data");
  //   }

  //   try {
  //     setLoading(true);

  //     const res = await uploadVendorExcel(tableData);

  //     if (res?.status) {
  //       alert(res?.message || "Uploaded Successfully");

  //       // ✅ CLEAR STATE (optional but clean)
  //       setTableData([]);
  //       setFilteredBills([]);
  //       setCurrentPage(1);

  //       // ✅ RELOAD PAGE
  //       window.location.reload();
  //     } else {
  //       alert(res?.message || "Upload failed");
  //     }

  //     setLoading(false);
  //   } catch (err) {
  //     console.error(err);
  //     alert("Upload failed");
  //     setLoading(false);
  //   }
  // };

  const downloadSampleExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sample");
 
  worksheet.columns = [
    { header: "Bidder_CompanyName", key: "Bidder_CompanyName", width: 30 },
    { header: "Address", key: "Address", width: 30 },
    { header: "City", key: "City", width: 20 },
    { header: "PinCode", key: "PinCode", width: 20 },
    { header: "GST_No", key: "GST_No", width: 25 },
    { header: "PAN_No", key: "PAN_No", width: 20 },
    { header: "TAN_No", key: "TAN_No", width: 20 },
    { header: "AadharNo", key: "AadharNo", width: 25 },
    { header: "Mobile_No", key: "Mobile_No", width: 20 },
    { header: "Email", key: "Email", width: 30 },
    { header: "Account_Number", key: "Account_Number", width: 25 },
    { header: "IFSC_CODE", key: "IFSC_CODE", width: 20 },
    { header: "BANK_NAME", key: "BANK_NAME", width: 25 },
    { header: "BranchName", key: "BranchName", width: 25 },
    { header: "Account_HolderName", key: "Account_HolderName", width: 30 },
    { header: "MICRNo", key: "MICRNo", width: 20 },
  ];
 
  worksheet.addRow({
    Bidder_CompanyName: "ABC Contractor",
    Address: "Pune Road",
    City: "Pune",
    PinCode: "411001",
    GST_No: "27ABCDE1234F1Z5",
    PAN_No: "ABCDE1234F",
    TAN_No: "ABCD12345E",
    AadharNo: "123456789012",
    Mobile_No: "9876543210",
    Email: "abc@gmail.com",
    Account_Number: "123456789012",
    IFSC_CODE: "SBIN0001234",
    BANK_NAME: "State Bank",
    BranchName: "Pune",
    Account_HolderName: "ABC Contractor",
    MICRNo: "411002002",
  });
 
  // Header Style
  worksheet.getRow(1).font = {
    bold: true,
    color: { argb: "FFFFFFFF" },
  };
 
  worksheet.getRow(1).fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "2C78DB" },
  };
 
  // Columns that must remain TEXT
  const textColumns = [
    "D", // PinCode
    "E", // GST_No
    "F", // PAN_No
    "G", // TAN_No
    "H", // AadharNo
    "I", // Mobile_No
    "K", // Account_Number
    "L", // IFSC_CODE
    "P", // MICRNo
  ];
 
  textColumns.forEach((col) => {
    worksheet.getColumn(col).numFmt = "@";
 
    worksheet.getColumn(col).eachCell((cell) => {
      cell.numFmt = "@";
    });
  });
 
  const buffer = await workbook.xlsx.writeBuffer();
 
  saveAs(
    new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    "Vendor_Sample.xlsx"
  );
};

  //--> old code
  // const downloadSampleExcel = () => {
  //   try {
  //     const sampleData = [
  //       {
  //         Bidder_CompanyName: "ABC Contractor",
  //         Address: "Pune Road",
  //         City: "Pune",
  //         PinCode: "411001",
  //         GST_No: "27ABCDE1234F1Z5",
  //         PAN_No: "ABCDE1234F",
  //         TAN_No: "ABCD12345E",
  //         AadharNo: "123456789012",
  //         Mobile_No: "9876543210",
  //         Email: "abc@gmail.com",
  //         Account_Number: "123456789012",
  //         IFSC_CODE: "SBIN0001234",
  //         BANK_NAME: "State Bank",
  //         BranchName: "Pune",
  //         Account_HolderName: "ABC Contractor",
  //         MICRNo: "411002002",
  //       },
  //     ];

  //     // ✅ Column letter helper
  //     const getColLetter = (index) => {
  //       let letter = "";
  //       while (index >= 0) {
  //         letter = String.fromCharCode((index % 26) + 65) + letter;
  //         index = Math.floor(index / 26) - 1;
  //       }
  //       return letter;
  //     };

  //     const headers = Object.keys(sampleData[0]);

  //     // ✅ These columns must stay as TEXT in Excel
  //     const textColumns = [
  //       "PinCode",
  //       "GST_No",
  //       "PAN_No",
  //       "TAN_No",
  //       "AadharNo",
  //       "Mobile_No",
  //       "Account_Number",
  //       "IFSC_CODE",
  //       "MICRNo",
  //     ];

  //     // ✅ Convert all values to string in sample data BEFORE creating sheet
  //     const stringifiedData = sampleData.map((row) => {
  //       const newRow = {};
  //       headers.forEach((key) => {
  //         newRow[key] = row[key] != null ? String(row[key]) : "";
  //       });
  //       return newRow;
  //     });

  //     // ✅ Create worksheet
  //     const worksheet = XLSX.utils.json_to_sheet(stringifiedData);

  //     // ✅ Force text format on sensitive columns (header + data rows)
  //     textColumns.forEach((colName) => {
  //       const colIndex = headers.indexOf(colName);
  //       if (colIndex === -1) return;

  //       const colLetter = getColLetter(colIndex);

  //       // Apply to all rows (row 1 = header, row 2 = data)
  //       for (let rowNum = 1; rowNum <= sampleData.length + 1; rowNum++) {
  //         const cellRef = `${colLetter}${rowNum}`;
  //         if (worksheet[cellRef]) {
  //           worksheet[cellRef].t = "s"; // type → string
  //           worksheet[cellRef].z = "@"; // format → Text
  //           worksheet[cellRef].v = String(worksheet[cellRef].v ?? ""); // value → string
  //         }
  //       }
  //     });

  //     // ✅ Set column widths for readability
  //     worksheet["!cols"] = headers.map(() => ({ wch: 22 }));

  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

  //     // ✅ Write as xlsx with type "array" to preserve text formatting
  //     const excelBuffer = XLSX.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //       cellStyles: true, // ✅ Required to preserve z (format) in output
  //     });

  //     const blob = new Blob([excelBuffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "Vendor_Sample.xlsx";
  //     a.click();
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error(error);
  //     alert("Failed to generate sample file");
  //   }
  // };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <h4 style={{ marginBottom: "15px" }}>Upload Vendor Excel</h4>

        {/* LOADER */}
        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.6)",
              backdropFilter: "blur(4px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                border: "6px solid #eee",
                borderTop: "6px solid #007bff",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                animation: "spin 1s linear infinite",
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: "10px" }}>
          <span
            onClick={downloadSampleExcel}
            style={{
              color: "#007bff",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            Download Sample Excel
          </span>
        </div>

        {/* FILE INPUT */}
        <div style={{ marginBottom: "15px" }}>
          <input
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileUpload}
            className="form-control"
          />
        </div>

        {/* TABLE */}
        {tableData.length > 0 && (
          <>
            <div
              style={{
                marginTop: "10px",
                borderRadius: "6px",
                overflow: "hidden",
                border: "1px solid #ccc",
              }}
            >
              {/* SCROLL CONTAINER */}
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  overflowX: "auto",
                }}
              >
                <table
                  style={{
                    minWidth: "2000px", // 🔥 forces horizontal scroll
                    borderCollapse: "collapse",
                    width: "100%",
                  }}
                >
                  {/* HEADER */}
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#2C78DB",
                      color: "white",
                      zIndex: 2,
                    }}
                  >
                    <tr>
                      {Object.keys(tableData[0]).map((col, i) => (
                        <th
                          key={i}
                          style={{
                            padding: "10px",
                            minWidth: "160px",
                            borderRight: "1px solid #ddd",
                            fontSize: "12px",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* BODY */}
                  <tbody>
                    {currentBills.map((row, i) => (
                      <tr
                        key={i}
                        style={{
                          background: i % 2 === 0 ? "#F8FBFF" : "#EAF4FB",
                        }}
                      >
                        {Object.values(row).map((val, j) => (
                          <td
                            key={j}
                            style={{
                              padding: "8px",
                              fontSize: "12px",
                              borderRight: "1px solid #eee",
                              borderBottom: "1px solid #eee",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {val?.toString()}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* PAGINATION */}
            <div
              style={{
                marginTop: "15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: "13px", color: "#555" }}>
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filteredBills.length)} of{" "}
                {filteredBills.length} entries
              </div>

              <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
 
                      <button
                        onClick={() => {
                          setShowAll(!showAll);
                          setCurrentPage(1);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          padding: "8px 16px",
                          borderRadius: "20px",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#fff",
                          background: showAll
                            ? "linear-gradient(135deg, #28a745, #20c997)"
                            : "linear-gradient(135deg, #0067ab, #0098d5)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {showAll ? "✓ Showing All" : "View All"}
                      </button>
                    </div>
              {/* <div style={{ display: "flex", gap: "5px" }}>
                <button
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                >
                  {"<<"}
                </button>
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  {"<"}
                </button>

                <span
                  style={{
                    padding: "5px 10px",
                    background: "#2C78DB",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  {currentPage}
                </span>

                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  {">"}
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  {">>"}
                </button>
              </div> */}
            </div>

            {/* SUBMIT */}
            <div style={{ textAlign: "right", marginTop: "20px" }}>
              <button
                onClick={handleSubmit}
                style={{
                  background:
                    "linear-gradient(to right, #3b409e, #0067ab, #0098d5)",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>

      <style>
        {`@keyframes spin {0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}
      </style>
    </div>
  );
};

export default VendorExcelUpload;
